export default {
  ROLE: 'USER_ROLE',
  ACCESS: 'USER_ACCESS',
  CLEAR_ROLE_ACCESS: 'CLEAR_USER_ROLE_ACCESS',
  SET_ROLE_ACCESS: 'SET_USER_ROLE_ACCESS',
}
